import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {TimelineLite} from "gsap";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";
import {ThorRandomWildsWPController} from "../../winpresentation/randomwilds/ThorRandomWildsWPController";
import {IconState} from "../../featureIcons/IIconView";

/**
 * Created by Jerker Nord on 2018-12-04.
 */

export class ThorMultiplierController extends ReelStopPresentationController {

    private _payoutMultiplierBefore:number;
    private _payoutMultiplierAfter:number;
    private _playMultiplierAwarded:boolean = false;
    private _playMjolnirtime:boolean = false;
    private _currentMode:string;
    private _nextMode:string;
    private _payoutMultiplier:number;
    private _disableMultiplierIcon:boolean = false;
    private _singleWin:number;
    private _addNewMultiplierTL:TimelineLite;
    private _doRestore:boolean;

    constructor(index:number) {
        super(index, "ThorMultiplierController");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
    }

    public abort():void {
        if(this._addNewMultiplierTL && this._addNewMultiplierTL.isActive()) {
            this._addNewMultiplierTL.pause();
            this._addNewMultiplierTL.kill();
        }
    }

    private onInitDataParsed(data:ThorParsedInitData) {
        this._payoutMultiplier = data.payoutMultiplier;
        this._doRestore = false;
        if(this._payoutMultiplier > 1) {
            if((data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN)
                || (data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)
                || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
                || (data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
                this._doRestore = true;
            }
        }
    }

    private onRestore():void {
        if (this._doRestore == true){
            ThorGameModuleConfig.thorMultiplierIconView.activateMultiplier(this._payoutMultiplier);
        }
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._singleWin = data.singleWin;
        this._payoutMultiplierBefore = data.payoutMultiplierBefore;
        this._payoutMultiplierAfter = data.payoutMultiplierAfter;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        if(data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_MULTIPLIER_FEATURE) {
            if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN) {
                this._playMultiplierAwarded = true;
            }
            if((data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) || (data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)) {
                this._playMjolnirtime = true;
                this._playMultiplierAwarded = true;
            }
        }

        if(this._payoutMultiplierAfter > 1 && (data.nextMode == ThorGameMode.NORMAL || data.nextMode == ThorGameMode.FREESPIN)) {
            this._disableMultiplierIcon = true;
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId == 3 && this._disableMultiplierIcon == true) {
            this._disableMultiplierIcon = false;
            if(this._singleWin > 0) {
                ThorGameModuleConfig.thorMultiplierIconView.disableMultiplierIconTL(1);
            } else {
                ThorGameModuleConfig.thorMultiplierIconView.disableMultiplierIconTL(0);
            }
        }

        if(this._playMultiplierAwarded == true && data.reelId == 4 && ((this._currentMode == ThorGameMode.NORMAL && this._nextMode == ThorGameMode.NUDGE_RESPIN) || (this._currentMode == ThorGameMode.FREESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS))) {
            this._playMultiplierAwarded = false;
            if(this._addNewMultiplierTL && this._addNewMultiplierTL.isActive()) {
                this._addNewMultiplierTL.pause();
                this._addNewMultiplierTL.kill();
            }
            this._addNewMultiplierTL = new TimelineLite({});
            if(this._playMjolnirtime == true) {
                this._playMjolnirtime = false;
                ThorGameModuleConfig.thorMjolnirtimeView.getMjolnirtimeAnimation().play();
                this._addNewMultiplierTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_STARTED)));
                this._addNewMultiplierTL.add(ThorGameModuleConfig.thorMultiplierIconView.enableMultiplierIconTL(this._payoutMultiplierAfter, (this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN)));
                this._addNewMultiplierTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE)));
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}